import { render, staticRenderFns } from "./DadosCadastrais.vue?vue&type=template&id=a7e1c8fe&scoped=true&"
import script from "./DadosCadastrais.vue?vue&type=script&lang=js&"
export * from "./DadosCadastrais.vue?vue&type=script&lang=js&"
import style0 from "./DadosCadastrais.vue?vue&type=style&index=0&id=a7e1c8fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e1c8fe",
  null
  
)

export default component.exports